import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${spacing.majorScale(1)}px;
`

export const OnlyMonthlyMessageContainer = styled.div`
  margin-bottom: ${spacing.majorScale(1)}px;
`

export const TooltipIconContainer = styled.div`
  display: inline-block;
  cursor: pointer;
  margin-left: ${spacing.majorScale(1)}px;
  vertical-align: middle;
  height: ${spacing.majorScale(2)}px;
  width: ${spacing.majorScale(2)}px;
`

export const TooltipContainer = styled.div`
  margin-top: ${spacing.majorScale(2)}px;
  max-width: 300px;
`
